import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "journey", "ticket", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--onboards--show--tickets`
    this.blockedAdd = false
  }

  doTicketsDashboard() {
    var html = `<div class="col-12 pl-1" data-users--works--activities--shared--tickets-target="main" data-controller="users--works--activities--shared--tickets"></div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--onboards--show--entity`).ticketsRowTarget.innerHTML = html)
    }).then(() => {

      var partyName = ``
      this.application.onboard.parties.forEach(party => {
        partyName += `| ${party.party_name} `
      })

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).permission = `operation_onboard_tickets`
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).blockedAdd = this.blockedAdd
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).sharing = false
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).kind = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).priority = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).term = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).itemsOnRow = 4
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).ticket_board = {
        board_id: this.application.onboard.id,
        board_type: `operation_onboards`,
        board_subtype: `${this.application.onboard.product_name}`,
        board_path: window.location.pathname,
        board_name: `Onboard ${this.application.onboard.product_service_pretty} ${this.application.onboard.product_accrual_name_pretty} ${partyName}`,
        date_id: this.application.onboard.date_id,
        date_type: `operation_dates`
      }
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).comment_board = {
        board_id: this.application.onboard.id,
        board_type: `operation_onboards`,
        date_id: this.application.onboard.date_id,
        date_type: `operation_dates`
      }

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
